import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, Inbox } from "lucide-react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { useMessageSocket } from "@/hooks/useMessageSocket";
import { useGetCallDispositionsQuery } from "@/store/rest_api";

const MessagesLayout = () => {
  useMessageSocket();
  useGetCallDispositionsQuery({});
  const location = useLocation();
  const navigate = useNavigate();
  const { setPage } = useBreadcrumbs();

  useEffect(() => {
    setPage("Inbox");
  }, []);

  const getActiveTab = () => {
    if (location.pathname.includes("/report")) {
      return "report";
    }

    return "inbox";
  };

  const handleTabChange = (value: string) => {
    navigate(value === "report" ? "/inbox/report" : "/inbox");
  };

  return (
    <div className="flex flex-col h-full">
      <div className="border-b border-border px-6 py-4 space-y-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Inbox</h1>
          <p className="text-muted-foreground">Texts, calls and voicemails from your contacts in one place</p>
        </div>
        <Tabs value={getActiveTab()} onValueChange={handleTabChange}>
          <TabsList>
            <TabsTrigger value="inbox" className="gap-2">
              <Inbox className="h-4 w-4" />
              Inbox
            </TabsTrigger>
            <TabsTrigger value="report" className="gap-2">
              <BarChart3 className="h-4 w-4" />
              Report
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <div className="flex-1 min-h-0 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default MessagesLayout;
